var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner__wrapper__1kzPN.spinner__centered__19TLF.spinner__inline__2B47E{text-align:center}.spinner__wrapper__1kzPN.spinner__centered__19TLF>.spinner__spinner__1Qtvp{margin:0 auto}.spinner__wrapper__1kzPN.spinner__inline__2B47E>.spinner__spinner__1Qtvp{display:inline-block;vertical-align:middle}.spinner__spinner__1Qtvp{background-image:url(" + escape(require("images/spinner.gif")) + ");background-size:30px 30px;display:block;height:30px;width:30px}.spinner__spinner__1Qtvp.spinner__small__36uxd{background-size:18px 18px;height:18px;width:18px}.spinner__spinner__1Qtvp.spinner__modLeft__3jNWW{margin-right:3px}", ""]);

// exports
exports.locals = {
	"wrapper": "spinner__wrapper__1kzPN",
	"centered": "spinner__centered__19TLF",
	"inline": "spinner__inline__2B47E",
	"spinner": "spinner__spinner__1Qtvp",
	"small": "spinner__small__36uxd",
	"modLeft": "spinner__modLeft__3jNWW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2445/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/loading/spinner.less
// module id = XI5F
// module chunks = 12